import { render, staticRenderFns } from "./ProfessorExpansionItem.vue?vue&type=template&id=840959bc&scoped=true"
import script from "./ProfessorExpansionItem.vue?vue&type=script&lang=js"
export * from "./ProfessorExpansionItem.vue?vue&type=script&lang=js"
import style0 from "./ProfessorExpansionItem.vue?vue&type=style&index=0&id=840959bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840959bc",
  null
  
)

export default component.exports